/**
 * Protected Route Component
 * Restricts access to authenticated users only
 */

import React from 'react';
import { useAuthContext } from '../contexts';
import { Navigate } from '@/i18n/navigation';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: ('tutor' | 'parent')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles }) => {
  const { firebaseUser, profile, loading } = useAuthContext();

  // Still loading auth state - don't redirect yet, just show loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!firebaseUser || !profile) {
    return <Navigate to="/" replace />;
  }

  // Role check if required roles specified
  if (requiredRoles && !requiredRoles.includes(profile.role as 'tutor' | 'parent')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
